import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class Owner {
  @Expose()
  @IsOptional()
  @IsString()
  userId!: string | null;

  @Expose()
  @IsNumber()
  ownerId!: number;

  @Expose()
  @IsNumber()
  type!: number;

  @Expose()
  @IsNumber()
  share!: number;

  @Expose()
  @IsString()
  name!: string;
}

export class LockData {
  @IsOptional()
  @Expose()
  @IsString()
  comment!: string | null;

  @Expose()
  @IsBoolean()
  isLocked!: boolean;
}

export class ContractorAdditionalSettingsResponse {
  @Expose()
  @IsBoolean()
  isPaymentMethodRestricted!: boolean;

  @Expose()
  @IsBoolean()
  summaryPrint!: boolean;

  @Expose()
  @Type(() => LockData)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  lockData!: LockData;

  @Expose()
  @IsArray()
  @Type(() => Owner)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  owners!: Array<Owner>;

  @Expose()
  @IsBoolean()
  showExchangePurchaseInformationOnInvoice!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  providerIdentity!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  supplierAccount!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  symbolsJPK!: string | null;
}
